import CryptoJS from "crypto-js";
const private_key = "38e7af3b87eea10116b35f742b235d9d22713c0d";

export function signHmacSHA256(val) {
  return CryptoJS.HmacSHA256(val, private_key).toString();
}
